<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="getProductionInfo"
            :value.sync="currentValue"
            display-expr="품번"
            value-expr="품번"
            content-template="contentTemplate"
            :disabled='getEdit'
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refProGrid'
              :data-source='getProductionInfo'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="검색..."
              />
              <DxFilterRow
                :visible="true"
                apply-filter="auto"
              />
              <DxColumn
                :allowEditing='false'
                caption="품목유형"
                data-field="품목유형"
                :visible='true'
                width='80'
                sort-order='asc'
              >
                <DxLookup
                  :data-source="itemTypeLookup"
                  display-expr="코드명"
                  value-expr="코드"
                />
              </DxColumn>
              <DxColumn
                caption="품번"
                data-field="품번"
                width = '120'>
              </DxColumn>
              <DxColumn
                sort-order='asc'
                caption="품명"
                data-field="품명">
              </DxColumn>
              <dx-paging :enabled="false"/>
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="multiple"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling, DxLookup, DxFilterRow,
  DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'
import ConstDef from '../../share/ConstDef'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
export default {
  name: 'ProductionGridComponent',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 400 },
      dataSource: null,
      gridHeight: 300,
      itemTypeLookup: null
    }
  },
  props: {
    option: { // display 품명 or 품번
      type: String,
      default: '품번'
    },
    value: {
      type: String,
      default: null
    },
    productionInfo: {
      type: Array,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
        // console.log(data)
      }
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox,
    DxLookup,
    DxFilterRow
  },
  computed: {
    getProductionInfo () {
      return this.productionInfo
    },
    getEdit () {
      // console.log(this.isEdit)
      return !this.isEdit
    }
  },
  created () {
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onSelectionChanged (e) {
      this.currentValue = e.selectedRowsData[0][this.option]
      this.onValueChanged(e.selectedRowsData[0][this.option])
      if (this.option === '품명') {
        this.$emit('selected-pcode', e.selectedRowsData[0].품번)
      } else if (this.option === '품번') {
        this.$emit('selected-pcode', e.selectedRowsData[0].품번)
      } else {
        this.$emit('selected-pcode', e.selectedRowsData[0].품명)
      }
      this.$refs.dropDownBoxRefName.instance.close()
    }
  }
}
</script>

<style lang="scss">

</style>
